export default __webpack_public_path__ + "static/media/Untitled-1-02.5493809a.png";